import { ReactNode } from 'react'
import SiteNoticeBanner from '../ui/SiteNoticeBanner'

interface Props {
  children: ReactNode
}

/** Wraps unauthenticated pages that should show the optional public site notice. */
export default function PublicPageLayout({ children }: Props) {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteNoticeBanner context="public" />
      <div className="flex-1">{children}</div>
    </div>
  )
}
